export default __webpack_public_path__ + "static/media/aliado-distrito106.f78c3208.png";